import { Inject } from '@angular/core';
import templateSource from './view.html';
              import { Component } from '@angular/core';
import Wiz from 'src/wiz';
let wiz = new Wiz('/wiz').app('page.kiera.chassis.item');
import { OnDestroy, OnInit } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import { Subscription } from 'rxjs';
import { Service } from 'src/libs/portal/season/service';


const chassisApi = new Wiz('/wiz').app('page.kiera.chassis');


@Component({
 standalone: false,
 selector: 'wiz-page-kiera-chassis-item',
template: templateSource || '',
    styles: [`

/* file: /opt/app/project/main/.kiera-build/src/app/page.kiera.chassis.item/view.scss */
:host {
  display: block;
  min-height: 100%;
}

.chassis-detail-frame {
  overflow-x: auto;
  border: 2px solid #334155;
  border-radius: 12px;
  background: #0f172a;
  padding: 10px;
  box-shadow: 0 12px 26px rgba(15, 23, 42, 0.12);
}

.chassis-detail-grid {
  display: grid;
  min-width: 520px;
  gap: 8px;
}

.chassis-detail-slot {
  position: relative;
  display: flex;
  min-width: 0;
  min-height: 104px;
  align-items: center;
  justify-content: center;
  overflow: hidden;
  border: 1px dashed #cbd5e1;
  border-radius: 8px;
  background: #f8fafc;
  color: #94a3b8;
  transition: border-color 140ms ease, background-color 140ms ease, transform 140ms ease;
}

.chassis-detail-slot.is-occupied {
  cursor: pointer;
  border-style: solid;
  border-color: #93c5fd;
  background: linear-gradient(145deg, #eff6ff, #dbeafe);
  color: #1d4ed8;
}

.chassis-detail-slot.is-occupied:hover {
  border-color: #3b82f6;
  background: #dbeafe;
  transform: translateY(-1px);
}

.chassis-detail-slot:disabled {
  cursor: default;
}

.chassis-detail-slot-index {
  position: absolute;
  left: 7px;
  top: 5px;
  font-size: 8px;
  font-weight: 700;
  color: #94a3b8;
}

.chassis-detail-node {
  display: flex;
  min-width: 0;
  max-width: 100%;
  flex-direction: column;
  align-items: center;
  gap: 3px;
  padding: 20px 8px 8px;
}

.chassis-detail-node i {
  font-size: 22px;
}

.chassis-detail-node b,
.chassis-detail-node small {
  display: block;
  max-width: 100%;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.chassis-detail-node b {
  font-size: 11px;
}

.chassis-detail-node small,
.chassis-detail-empty {
  font-size: 9px;
}

@media (max-width: 767px) {
  .chassis-detail-grid {
    min-width: 640px;
  }
  .chassis-detail-slot {
    min-height: 92px;
  }
}`],
})
export class PageKieraChassisItemComponent implements OnInit, OnDestroy {
    public loading: boolean = true;
    public errorMessage: string = '';
    public id: number = 0;
    public tab: string = 'summary';
    public item: any = null;
    public tabs: any[] = [
        { key: 'summary', label: 'Summary', icon: 'bx bx-info-circle' },
        { key: 'nodes', label: 'Node', icon: 'bx bx-server' },
        { key: 'placement', label: '배치', icon: 'bx bx-grid-alt' },
    ];
    private routerSub: Subscription;

    constructor(@Inject( Service) public service: Service,@Inject( Router)  private router: Router) { }

    public async ngOnInit() {
        await this.service.init();
        this.applyRoute();
        if (this.id <= 0) {
            this.service.href('/kiera/chassis');
            return;
        }
        await this.load();

        this.routerSub = this.router.events.subscribe(async (event) => {
            if (!(event instanceof NavigationEnd)) return;
            const previousId = this.id;
            this.applyRoute();
            if (this.id <= 0) {
                this.service.href('/kiera/chassis');
                return;
            }
            if (this.id !== previousId) {
                await this.load();
                return;
            }
            await this.service.render();
        });
    }

    public ngOnDestroy() {
        if (this.routerSub) this.routerSub.unsubscribe();
    }

    private applyRoute() {
        this.id = Number(WizRoute.segment.id || 0);
        const requestedTab = String(WizRoute.segment.tab || 'summary');
        this.tab = this.tabs.some((item: any) => item.key === requestedTab)
            ? requestedTab
            : 'summary';
    }

    public async load() {
        this.loading = true;
        this.errorMessage = '';
        this.item = null;
        await this.service.render();
        try {
            const { code, data } = await chassisApi.call('load');
            if (code !== 200) {
                this.errorMessage = data?.message || 'Chassis 정보를 불러오지 못했습니다.';
                return;
            }
            const chassis = Array.isArray(data?.chassis) ? data.chassis : [];
            this.item = chassis.find((entry: any) => Number(entry?.id || 0) === this.id) || null;
            if (!this.item) {
                this.errorMessage = 'Chassis를 찾을 수 없습니다.';
            }
        } catch (error) {
            this.errorMessage = String(error || 'Chassis 정보를 불러오지 못했습니다.');
        } finally {
            this.loading = false;
            await this.service.render();
        }
    }

    public selectTab(tab: string) {
        if (!this.tabs.some((item: any) => item.key === tab)) return;
        this.service.href(`/kiera/chassis/${this.id}/${tab}`);
    }

    public openNode(node: any) {
        const nodeId = Number(node?.id || node?.node_id || 0);
        if (nodeId <= 0) return;
        this.service.href(`/kiera/nodes/${nodeId}/summary`);
    }

    public get nodes(): any[] {
        return Array.isArray(this.item?.nodes) ? this.item.nodes : [];
    }

    public get slotRows(): number {
        return Math.max(1, Number(this.item?.slot_rows || 1));
    }

    public get slotColumns(): number {
        return Math.max(1, Number(this.item?.slot_columns || 1));
    }

    public get slotCount(): number {
        return this.slotRows * this.slotColumns;
    }

    public get placementGridColumns(): string {
        return `repeat(${this.slotColumns}, minmax(0, 1fr))`;
    }

    public get placementSlots(): any[] {
        const nodeBySlot = new Map<string, any>();
        this.nodes.forEach((node: any) => {
            const key = `${Number(node?.slot_row || 0)}:${Number(node?.slot_column || 0)}`;
            nodeBySlot.set(key, node);
        });
        const slots: any[] = [];
        for (let row = 1; row <= this.slotRows; row += 1) {
            for (let column = 1; column <= this.slotColumns; column += 1) {
                const key = `${Number(row)}:${Number(column)}`;
                slots.push({
                    row,
                    column,
                    node: nodeBySlot.get(key) || null,
                });
            }
        }
        return slots;
    }

    public trackSlot(_index: number, slot: any): string {
        return `${Number(slot?.row || 0)}:${Number(slot?.column || 0)}`;
    }

    public trackNode(_index: number, node: any): number {
        return Number(node?.id || node?.node_id || 0);
    }

    public isActive(): boolean {
        return this.item?.active !== false && this.item?.active !== 0 && this.item?.active !== '0';
    }

    public chassisStatusLabel(): string {
        if (!this.isActive()) return '비활성';
        return Number(this.item?.rack_record_id || 0) > 0 ? 'Rack 배치' : '미배치';
    }

    public chassisStatusClass(): string {
        if (!this.isActive()) return 'bg-slate-100 text-slate-500';
        return Number(this.item?.rack_record_id || 0) > 0
            ? 'bg-emerald-50 text-emerald-700'
            : 'bg-blue-50 text-blue-700';
    }

    public nodeStatusClass(node: any): string {
        const status = String(node?.status || '').trim().toLowerCase();
        if (['ready', 'active', 'online', 'success', 'up'].some((value: string) => status.includes(value))) {
            return 'bg-emerald-50 text-emerald-700';
        }
        if (['fail', 'error', 'down', 'offline'].some((value: string) => status.includes(value))) {
            return 'bg-rose-50 text-rose-700';
        }
        return 'bg-slate-100 text-slate-600';
    }

    public nodeStatusLabel(node: any): string {
        return String(node?.status || '').trim() || '상태 미확인';
    }
}

export default PageKieraChassisItemComponent;
